<template>
  <div class="formgrid grid">
    <div class="field col">
      <label for="firstname2">Barcode</label>
      <input
        id="firstname2"
        type="text"
        :value="props.barcode"
        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
      >
    </div>
    <div class="field col">
      <label for="lastname2">Asset Name</label>
      <input
        id="lastname2"
        type="text"
        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
      >
    </div>
  </div>
  <div class="field">
    <label for="fault">Fault</label>
    <TextArea
      id="fault"
      auto-resize
      rows="5"
      cols="30"
    />
  </div>
  <div class="field">
    <label for="lastname2">Log Date</label>
    <input
      id="lastname2"
      type="text"
      class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
    >
  </div>
  <label for="lastname2">Log Person</label>
  <input
    id="lastname2"
    type="text"
    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
  >
</template>

<script setup>
import { ref, defineProps, onMounted } from 'vue'
import { createAsset, createRepairs } from '@/data/faker';
// Define props to receive the barcode from the parent
const props = defineProps({
    barcode: {
        type: String,
        default: ''
    }
});

const createdAsset = ref([])
const assetName = ref('')
const createdRepair = ref([])
const repairPerson = ref([])


onMounted(() => {
    createdAsset.value = createAsset(1)
    createdRepair.value = createRepairs()
    assetName.value = createdAsset.value.name
    repairPerson.value = createdRepair.value.logPerson


})


</script>

<style scoped></style>